import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import React, {Component} from 'react';
import PropTypes from 'prop-types'

class DefaultTabs extends Component {
    constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected,
      tabIndex: null
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.base.createDs !== prevProps.base.createDs) {
      this.setState({selected: 0}, () => {this.setState({tabIndex: null})});
    }
  }

  getDefaultProps() {
    return {
      selected: 0
    };
  }
  getInitialState() {
    return {
      selected: this.props.selected
    };
  }
  handleClick(index, event) {
    event.preventDefault();
    this.setState({
      selected: index
    });
  }
  propTypes: {
    selected: PropTypes.number,
    children: PropTypes.array,
    children: PropTypes.element
  }
  _renderTitles() {
    function labels(child, index) {
      let activeClass = (this.state.selected === index ? 'nav-link active' : 'nav-link');
      return (
        child !== null ?
          <li key={index} className="nav-item">
            <a href={null} style={{"cursor": "pointer"}}
              className={activeClass}
              onClick={this.handleClick.bind(this, index)}>
              {child.props.label}
            </a>
          </li>
        : null
      );
    }
    return (
      <ul className="nav nav-tabs">
        {
          this.props.children.map(labels.bind(this))
        }
      </ul>
    );
  }
  _renderContent() {
    return (
      <div>
        {
          this.state.tabIndex !== null
          ? this.state.selectedTab[this.state.tabIndex]
          : this.props.children[this.state.selected]
        }
      </div>
    );
  }
  render() {
    return (
      <div>
        {this._renderTitles()}
        {this._renderContent()}
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        locales: state.i18n,
        localesReducer: state.localesReducer,
        base: state.base
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultTabs);


// WEBPACK FOOTER //
// ./src/components/body/DefaultTabs.js